import * as React from 'react';
import './PlaceholderBlock.scss';

// #region Component Props

interface IProps {
    message         : string;
    icon?           : string;
}

// #endregion 

const PlaceholderBlock = (props:IProps) => {

    const { message, icon } = props;

    return <div className="placeholder-block">
            { message }
            <br/>
            <i className={'la ' + (icon ? icon : 'la-search' )} />
        </div> 
}

PlaceholderBlock.defaultProps = {
    icon: 'la-search'
}

export { PlaceholderBlock }